module.exports = __webpack_public_path__ + "assets/img/ad3.1ada1084.svg";